import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbNavModule,} from "@ng-bootstrap/ng-bootstrap";
import {TemplateDto, TemplateSubmisionRequest, TemplateSubmissionHTS} from "../../shipper";
import {VesselData} from "./isf.vessel.form";
import {PartiesData} from "./isf.parties.form";
import {IsfBillsForm} from "./bills/isf.bills.form";
import {TemplateService} from "../template.service";
import {AsyncPipe, NgIf} from "@angular/common";
import {IsfFormSpinnerService} from "./isf.form.spinner";
import {ToastrService} from "ngx-toastr";
import {IsfHtsMf} from "./isf.hts.mf";

@Component({
	selector: 'isf-form',
	standalone: true,
	imports: [
		NgbNavModule,
		VesselData,
		PartiesData,
		IsfBillsForm,
		AsyncPipe,
		NgIf,
		IsfHtsMf
	],
	template: `

        <div id="spinner" *ngIf="spinner.visibility | async" class="spinner">
            <div class="lds-ripple"><div></div><div></div></div>
        </div>
		
		<div class="modal-dialog modal-dialog-scrollable modal-fullscreen ">
			<div class="modal-content">
				<div class="modal-header bg-dark">
                    <i class="fa fa-asterisk"></i>ISF
                    <button type="button" class="btn-close text-bg-info pull-right" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
     
				</div>
				<div class="modal-body">
					
					<div class="container-fluid">
						<div class="row">
							<div class="col-12">

                                <div class="">

                                    <div class="mt-1 mt-sm-2 ">
                                        <isf-parties #parties [(isf)]="isf" [template]="template"></isf-parties>
                                    </div>

                                    <div class="mb-3 mt-4 mt-sm-4 card border-1 p-2 ">
                                        <isf-bills [(isf)]="isf"></isf-bills>
                                    </div>

                                    <div class="mb-3 mt-4 mt-sm-4 card border-1 p-2 ">
                                        <hts-mf #hts [template]="template"></hts-mf>
                                    </div>

                                    <div class="mb-3 mt-4 mt-sm-4 border-1">
                                        <vessel-info [(isf)]="isf" [template]="template"></vessel-info>
                                    </div>

                                </div>
								
							</div>
						</div>
						
					</div>
					
				</div>
				<div class="modal-footer">
					<button class="btn btn-primary" (click)="submit()">Submit</button>
				</div>
			</div>
		</div>
	`,
	styleUrl:'isf.form.css'
})
export class IsfFormComponent implements OnInit{
	
	@Input()
	template!:TemplateDto;
	
	@ViewChild("parties",{static: true})
	parties!:PartiesData;
	
	@ViewChild("hts",{static:true})
	hts!:IsfHtsMf;
	
	@Output()
	onSubmit:EventEmitter<void> = new EventEmitter();
	
	isf!:TemplateSubmisionRequest;
	
	
	constructor(public modal:NgbActiveModal, private templateService:TemplateService, public spinner:IsfFormSpinnerService,private toastr: ToastrService) {}
	
	
	ngOnInit(): void {
		
		let today = new Date();
		
		let tomorrow = new Date().setDate(today.getDate() + 1)
		let twoWeeks = new Date().setDate(today.getDate() + 15);
		
		// @ts-ignore
		this.isf = <TemplateSubmisionRequest>{
			templateId: this.template?.id,
			vessel: "ISF",
			voyage: "1",
			totalWeightUom:"KG",
			totalWeight:"1",
			etd: new Date(tomorrow).toISOString().substring(0,10),
			eta: new Date(twoWeeks).toISOString().substring(0,10)
		};
    }
	
	
	submit(){
		
		let errors:Array<{field:string, msg:string}> = [];
		
		
		this.isf.hts = this.hts.getHtsParties()
			.map((p) => <TemplateSubmissionHTS>{hts:p.hts, manufacturer:p.manufacturer.mid});
		
		
		if(this.isf.hts.length == 0){
			errors.push({field:"HTS",msg:"A tarrif number is required"});
		}
		
		this.isf.hts.forEach((hts) => {
			hts.hts.filter(h => h.hts == "")
				.forEach(h => errors.push({field:"HTS",msg:"A tarrif number is required"}))
		})
		
		if(!this.isf.bills || this.isf.bills.length == 0){
			errors.push({field:"BL",msg:"At least 1 bill number is required"});
		}
		
		if(this.isf.bills){
			this.isf.bills
				.filter(b => b.billNumber == "" || b.billNumber == null)
				.forEach(b => errors.push({field:"BL",msg:"Bill numbers cannot be blank"}));
		}
		
		
		if(errors.length > 0){
			
			let e = errors.map((er) => er.field +": "+er.msg);
			
			this.toastr.error(e.join("<br/>"),"Mistakes were made",{
				timeOut:30000,
				positionClass: 'toast-top-center',
				progressBar:true,
				//closeButton:true,
				enableHtml: true
			});
			
			return;
		}
		
		//console.log(this.isf);
		
		//return;
		this.templateService.submitIsf(this.isf).subscribe({
			
			next:(res) => {
				
				this.toastr.success("Submitted","Success",{
					//timeOut:0,
					positionClass: 'toast-top-center',
					progressBar:true,
					//closeButton:true,
					enableHtml: true
				});
				
				this.onSubmit.emit();
			},
			error: (err)=> {
				this.toastr.error("There was a communication error","Error",{
					positionClass: 'toast-top-center',
				});
		},
			complete:() => {}
		});
		
	}
}
